import React, { Component, Fragment } from 'react'
import { Button, Alert, Icon } from 'antd'
import { inject, observer } from 'mobx-react'
import ProviderSelect from '@components/ProviderSelect'
import { groupPolicyProviders } from '@services/api'

@inject((store: any) => {
    const { popupStore, providerStore, authStore } = store
    return { popupStore, providerStore, authStore }
})
@observer
export default class ProviderPolicies extends Component<any, any> {
    state = {
        error: null
    }

    handlePoliciesActions = async status => {
        await this.props.providerStore.resetSelected()
        this.props.updatePoliciesActions(status)
    }

    handleDetachPolicies = async () => {
        const { id } = this.props
        try {
            await groupPolicyProviders.detachPolicies(id)
            this.updatePolicies()
        } catch (e) {
            this.setState({ error: 'בעיה בחיבור לשרת' })
            console.log(e)
        }
    }

    handleUpdatePolicies = async () => {
        const { id, providerStore } = this.props
        if (!providerStore.selectedId) {
            this.setState({ error: 'עליך לבחור מעסיק חדש אליו תרצה לשייך את הפוליסות' })
        } else {
            this.setState({ error: null })
            try {
                await groupPolicyProviders.updatePolicies({ id, newProviderId: providerStore.selectedId })
                this.updatePolicies()
            } catch (e) {
                this.setState({ error: 'בעיה בחיבור לשרת' })
                console.log(e)
            }
        }
    }

    updatePolicies = async () => {
        const { popupStore, id } = this.props
        const relatedPolicies = (await groupPolicyProviders.relatedPolicies({ id })).data
        await popupStore.togglePopup('editProvider', { ...popupStore.info, relatedPolicies })
        this.props.updatePoliciesActions(null)
    }

    render() {
        const { relatedPolicies, policiesActions, authStore } = this.props
        const { error } = this.state
        let content
        if (relatedPolicies) {
            if (relatedPolicies.length > 0) {
                let actions
                switch (policiesActions) {
                    case 'REMOVE':
                        actions = (
                            <div>
                                <div style={{ margin: '0.5rem 0' }}>
                                    <strong style={{ color: 'red' }}>
                                        אזהרה! הינך עומד להסיר שיוך כל הפוליסות למעסיק זה, פעולה זו לא ניתנת לשחזור
                                    </strong>
                                </div>
                                <Button size="small" type="danger" onClick={() => this.handleDetachPolicies()}>
                                    הסר שיוך פוליסות למעסיק
                                </Button>
                                <Button size="small" onClick={() => this.handlePoliciesActions(null)}>
                                    ביטול
                                </Button>
                            </div>
                        )
                        break
                    case 'REASSIGN':
                        actions = (
                            <div>
                                <div style={{ margin: '0.5rem 0' }}>
                                    <strong style={{ color: 'red' }}>
                                        אזהרה! פעולה זו תסיר את הקשר של הפוליסות המקושרות למעסיק זה ותקשר אותן למעסיק
                                        הנבחר
                                    </strong>
                                </div>
                                <ProviderSelect disable={false} />
                                <div style={{ color: 'red', marginBottom: '0.5rem' }}>{error ? error : ''}</div>
                                <Button size="small" type="danger" onClick={() => this.handleUpdatePolicies()}>
                                    שייך פוליסות למעסיק
                                </Button>
                                <Button size="small" onClick={() => this.handlePoliciesActions(null)}>
                                    ביטול
                                </Button>
                            </div>
                        )
                        break
                    default:
                        actions = ''
                        break
                }
                const policiesCount = (
                    <Fragment>
                        <div>
                            <strong>{relatedPolicies.length} פוליסות משוייכות למעסיק זה </strong>
                        </div>
                        {authStore.roles[0] === 'admin' ? (
                            <Fragment>
                                <Button
                                    style={{ marginTop: '0.5rem' }}
                                    size="small"
                                    onClick={() => this.handlePoliciesActions('REASSIGN')}
                                >
                                    <Icon type="link" />
                                    <span>שיוך פוליסות למעסיק אחר</span>
                                </Button>
                                <Button size="small" onClick={() => this.handlePoliciesActions('REMOVE')}>
                                    <Icon type="disconnect" />
                                    <span>הסר שיוך למעסיק זה</span>
                                </Button>
                                {actions}
                            </Fragment>
                        ) : (
                            ''
                        )}
                    </Fragment>
                )
                content = <Alert message={policiesCount} showIcon type="warning" />
            } else {
                content = <Alert message="אין פוליסות המשוייכות למעסיק זה" type="info" />
            }
        }
        return <div>{content}</div>
    }
}
